import { render, staticRenderFns } from "./sb_doc_edit.vue?vue&type=template&id=dadfc7b8&scoped=true&"
import script from "./sb_doc_edit.vue?vue&type=script&lang=js&"
export * from "./sb_doc_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadfc7b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dadfc7b8')) {
      api.createRecord('dadfc7b8', component.options)
    } else {
      api.reload('dadfc7b8', component.options)
    }
    module.hot.accept("./sb_doc_edit.vue?vue&type=template&id=dadfc7b8&scoped=true&", function () {
      api.rerender('dadfc7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/doc/edit/sb_doc_edit.vue"
export default component.exports